import React from 'react';
import { X } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';

export const ModalWrapper = ({ title, children, onClose, maxWidth = '450px' }) => (
  <div 
    style={{ 
      position: 'fixed', 
      inset: 0, 
      backgroundColor: 'rgba(0,0,0,0.8)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      zIndex: 1100 
    }} 
    onClick={onClose}
  >
    <div 
      style={{ 
        backgroundColor: COLORS.card, 
        borderRadius: '16px', 
        padding: '24px', 
        width: '100%', 
        maxWidth, 
        maxHeight: '90vh', 
        overflowY: 'auto' 
      }} 
      onClick={(e) => e.stopPropagation()}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3 style={{ color: COLORS.text, fontSize: '18px', fontWeight: '700', margin: 0 }}>{title}</h3>
        <button 
          onClick={onClose} 
          style={{ background: 'none', border: 'none', color: COLORS.textSecondary, cursor: 'pointer' }}
        >
          <X size={20} />
        </button>
      </div>
      {children}
    </div>
  </div>
);

export const FormInput = ({ label, value, onChange, type = 'text', placeholder = '', disabled = false }) => (
  <div style={{ marginBottom: '12px' }}>
    <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>
      {label}
    </label>
    <input 
      type={type} 
      value={value} 
      onChange={(e) => onChange(e.target.value)} 
      placeholder={placeholder}
      disabled={disabled}
      style={{ 
        width: '100%', 
        padding: '12px', 
        backgroundColor: COLORS.background, 
        border: `1px solid ${COLORS.border}`, 
        borderRadius: '8px', 
        color: COLORS.text, 
        fontSize: '14px', 
        boxSizing: 'border-box',
        opacity: disabled ? 0.6 : 1
      }} 
    />
  </div>
);

export const FormSelect = ({ label, value, onChange, options, placeholder = 'Выберите...' }) => (
  <div style={{ marginBottom: '12px' }}>
    <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>
      {label}
    </label>
    <select 
      value={value} 
      onChange={(e) => onChange(e.target.value)}
      style={{ 
        width: '100%', 
        padding: '12px', 
        backgroundColor: COLORS.background, 
        border: `1px solid ${COLORS.border}`, 
        borderRadius: '8px', 
        color: COLORS.text, 
        fontSize: '14px', 
        boxSizing: 'border-box' 
      }}
    >
      <option value="">{placeholder}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);

export const SubmitButton = ({ onClick, loading, disabled, children }) => (
  <button
    onClick={onClick}
    disabled={loading || disabled}
    style={{
      width: '100%',
      padding: '14px',
      backgroundColor: loading || disabled ? COLORS.border : COLORS.primary,
      border: 'none',
      borderRadius: '8px',
      color: loading || disabled ? COLORS.textSecondary : '#000',
      fontSize: '14px',
      fontWeight: '600',
      cursor: loading || disabled ? 'not-allowed' : 'pointer',
    }}
  >
    {loading ? 'Загрузка...' : children}
  </button>
);

export default { ModalWrapper, FormInput, FormSelect, SubmitButton };
